import { UserButton } from "@clerk/react";
import { Hourglass } from "lucide-react";
import { useMe } from "@/context/MeContext";

export default function PendingPage() {
  const me = useMe();
  return (
    <div className="min-h-screen hero-bg grid place-items-center px-6" data-testid="pending-page">
      <div className="max-w-sm text-center space-y-5 fade-up">
        <Hourglass className="w-12 h-12 text-[#FFB300] mx-auto" />
        <h1 className="font-display text-3xl font-black uppercase text-white">Aguardando aprovação</h1>
        <p className="text-slate-400 text-sm">
          Sua conta <span className="text-white" data-testid="pending-email">{me.email}</span> foi registrada. Um administrador da produção precisa liberar seu acesso.
        </p>
        <div className="flex justify-center"><UserButton /></div>
      </div>
    </div>
  );
}
